"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GetUserResponse", {
    enumerable: true,
    get: function() {
        return GetUserResponse;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const GetUserResponse = _zod.z.object({
    company: _zod.z.instanceof(_bson.ObjectId),
    _id: _zod.z.instanceof(_bson.ObjectId),
    // get just integrations field from CustomFieldModel
    department: _zod.z.object({
        _id: _zod.z.instanceof(_bson.ObjectId),
        name: _zod.z.string()
    }).nullable(),
    departmentAdmin: _zod.z.array(_zod.z.object({
        _id: _zod.z.instanceof(_bson.ObjectId),
        name: _zod.z.string()
    })),
    directReports: _zod.z.array(_zod.z.object({
        _id: _zod.z.instanceof(_bson.ObjectId),
        name: _zod.z.string()
    })),
    contributesTo: _zod.z.array(_zod.z.object({
        _id: _zod.z.instanceof(_bson.ObjectId),
        name: _zod.z.string()
    })),
    invited: _zod.z.boolean().nullish().default(true),
    email: _zod.z.string().nullable(),
    name: _zod.z.string().catch(""),
    lastSeen: _utilsisomorphic.transformDateToUTCString.nullish(),
    deactivated: _zod.z.object({
        user: _zod.z.string().or(_zod.z.instanceof(_bson.ObjectId)).nullish(),
        at: _utilsisomorphic.transformDateToUTCString.optional()
    }).or(_zod.z.boolean()).nullish(),
    hasAvatar: _zod.z.boolean().optional()
});
